import { ReactNode, createContext, useState } from 'react';

type OnboardingContextProps = {
  children: ReactNode;
};

export type EtapaOnboarding = {
  id: string;
  ordem: number;
  grupo: string;
  status: 'pendente' | 'em_progresso' | 'concluido';
  automatico: boolean;
  concluido_em: string | null;
};

export type OnboardingData = {
  empresa_id: string;
  iniciado_por_usuario: string;
  onboarding_concluido: boolean;
  concluido_em: string | null;
  porcentagem: number;
  total_etapas: number;
  etapas: EtapaOnboarding[];
  criado_em: string;
  atualizado_em: string;
  exists?: boolean;
};

type OnboardingContextType = {
  onboardingData: OnboardingData | null;
  setOnboardingData: (data: OnboardingData | null) => void;
  onboardingCarregado: boolean;
  setOnboardingCarregado: (loaded: boolean) => void;
  etapaAtual: string | null;
  setEtapaAtual: (etapa: string | null) => void;
};

const initialValues: OnboardingContextType = {
  onboardingData: null,
  setOnboardingData: () => {},
  onboardingCarregado: false,
  setOnboardingCarregado: () => {},
  etapaAtual: null,
  setEtapaAtual: () => {},
};

export const OnboardingContext = createContext<OnboardingContextType>(initialValues);

export const OnboardingContextProvider = ({ children }: OnboardingContextProps) => {
  const [onboardingData, setOnboardingData] = useState<OnboardingData | null>(null);
  const [onboardingCarregado, setOnboardingCarregado] = useState(false);
  const [etapaAtual, setEtapaAtual] = useState<string | null>(null);

  return (
    <OnboardingContext.Provider value={{
      onboardingData, setOnboardingData,
      onboardingCarregado, setOnboardingCarregado,
      etapaAtual, setEtapaAtual,
    }}>
      {children}
    </OnboardingContext.Provider>
  );
};
